"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useLazyRef = void 0;
var react_1 = require("react");
var noValue = Symbol('lazyRef.noValue');
var useLazyRef = function useLazyRef(getInitialValue) {
  var lazyRef = (0, react_1.useRef)(noValue);
  if (lazyRef.current === noValue) {
    lazyRef.current = getInitialValue();
  }
  return lazyRef;
};
exports.useLazyRef = useLazyRef;